/** @format */

import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Typography from "../../atoms/typography/Typography";
import { SubNavbarProps } from "./SubNavbar.types";
import DropdownButton from "../../atoms/dropdownButton/DropdownButton";
import Box from "../../atoms/box/Box";
import Button from "../../core/button/Button";
import { cn } from "../../../util/classNameConstructor";
import Dropdown from "../../core/dropdown/Dropdown";

const Wrapper = styled.div<{ showBorder: boolean | undefined }>`
  // THIS IS JUST FASTLY DIRTY DONE, NEEDS TO BE REFACTORED
  width: 100%;

  position: sticky;
  top: 0px;
  display: flex;
  align-items: ${({ header }) => (header ? "center" : "flex-start")};
  justify-content: space-between;
  z-index: 999;
  margin-top: ${({ header }) => (header ? "0px" : "16px")};
  padding: 0px 16px 0px 24px;
  height: ${({ header, mainHeader }) =>
    mainHeader ? "160px" : header ? "70px" : "0"};
  /* height: 0px; */
  pointer-events: none;
  text-align: left;
  /* 
  @media (min-width: 768px) {
    position: sticky;
    align-items: flex-start;

    background-color: ${({ theme }) => theme.colors.palette["grey-50"]};
    z-index: 99;
    border-radius: ${({ theme }) => theme.radii[5]}px
      ${({ theme }) => theme.radii[5]}px 0px 0px;
    border-bottom: 1.5px solid
      ${({ theme, showBorder }) =>
    showBorder ? theme.colors.palette["grey-500"] : "transparent"};
  } */

  @media (max-width: 768px) {
    height: auto;
    padding: 0px 0px 0px 0px;
  }
`;

const SubNavbar: FC<SubNavbarProps> = ({
  header,
  mainHeader,
  handleButtonBack,
  handleButtonClose,
  handleButtonEditData,
  showBorder,
  homeRoute,
  withHeaderBorder,
  initialFocusRef,
  closeButtonTooltipLabel
}) => {
  const { t } = useTranslation();
  const ClickProps = handleButtonBack
    ? {
        onClick: (e) => {
          e.stopPropagation();
          handleButtonBack(e);
        },
      }
    : {
        to: window.history.length < 2 ? homeRoute : -1,
      };
  return (
    <Wrapper
      showBorder={showBorder}
      header={header}
      mainHeader={mainHeader}
      className={cn(withHeaderBorder ? "border-border-subdued border-b" : null)}
    >
      <h3 className="heading-lg ml-1 w-full text-start">{header}</h3>

      <div className="pointer-events-all flex h-9 gap-2">
        {handleButtonEditData && (
          <Dropdown
            variant="shapeless"
            size="md"
            leadingIcon="more"
            aria-label={t("global:more")}
            trailingIcon={false}
            items={handleButtonEditData}
          />
        )}

        {handleButtonClose && (
          <Button
            leadingIcon="x-md"
            tooltipLabel={closeButtonTooltipLabel ||t("global:close")}
            size="md"
            ref={initialFocusRef}
            onClick={(e) => {
              e.stopPropagation();
              handleButtonClose();
            }}
          />
        )}
      </div>
    </Wrapper>
  );
};

export default memo(SubNavbar);
